export default __webpack_public_path__ + "static/media/R_wdt_c_cap_2.9ab7e1c6.mp3";